var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstellationB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 101,
    viewBox: "0 0 165 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9198 57.216L47.6994 57.4387L11.098 18.7752L11.3185 18.4783L47.9198 57.216Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8508 89.0522L70.5568 89.2748L47.6993 57.4386L47.9198 57.216L70.8508 89.0522Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5256 90.0911H74.1581L76.2895 62.0397L76.657 62.1139L74.5256 90.0911Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7583 32.5391L67.407 32.6481L76.3898 62.1581L76.7411 62.049L67.7583 32.5391Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1199 87.0384L73.0486 90.0245L73.0974 90.3922L95.1687 87.4061L95.1199 87.0384Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3499 87.1738L95.0145 87.3256L99.6738 97.8228L100.009 97.671L95.3499 87.1738Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.802 93.593L99.8282 97.5726L99.8994 97.9367L119.873 93.957L119.802 93.593Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.566 65.917L119.695 93.6194L119.978 93.857L142.849 66.1546L142.566 65.917Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.143 66.4923L126.635 61.5202L126.782 61.1492L142.29 66.1213L142.143 66.4923Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.708 61.1491H126.414L127.076 38.7377L127.443 38.8119L126.708 61.1491Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.352 27.6804L127.37 38.5893L127.076 38.3667L134.058 27.532L134.352 27.6804Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.078 11.7252L134.425 27.4577L134.205 27.1609L154.857 11.4283L155.078 11.7252Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0401 78.5143L77.833 83.7091L82.8308 83.4122L79.5969 88.1617L84.0802 90.388L79.3029 92.8369L81.2138 97.5863L76.5101 96.3248L74.3786 100.852L71.7328 95.4343L66.147 97.9574L67.9109 91.798L62.3252 88.4585L68.5724 86.3064L67.5435 80.2212L73.0557 83.5606L75.0401 78.5143Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7149 7.27258L15.5078 12.4673L20.5791 12.1705L17.2717 16.9199L21.755 19.1462L16.9777 21.5951L18.9621 26.3446L14.1849 25.083L12.0535 29.6098L9.40757 24.1925L3.82183 26.7156L5.58575 20.5562L0 17.2167L6.24722 15.0646L5.21826 8.97942L10.7305 12.3189L12.7149 7.27258Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.579 0L156.915 3.93314L161.546 1.92946L160.076 7.56943L165 8.16312L161.325 12.022L164.78 15.881L159.929 16.252L159.341 21.2983L155.078 17.0683L150.668 21.2983L150.301 14.9904L143.906 13.7289L149.051 9.57311L146.111 4.22998L152.359 5.41734L152.579 0Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0379 51.5018L49.0958 54.8413L53.0646 55.1381L50.4187 58.255L51.5212 62.1139L47.7728 60.4813L44.4655 62.7818L44.833 58.7002L41.7461 56.1771L45.6414 55.1381L47.0379 51.5018Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3207 59.8876L75.187 60.036L76.951 57.7355L77.7594 60.6297L80.5523 61.5944L77.9799 63.1528V66.1212L75.7015 64.1918L72.9087 65.0823L73.9376 62.2623L72.3207 59.8876Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.739 59.0713L125.606 59.2197L127.443 56.9192L128.178 59.8134L130.971 60.7781L128.399 62.3365L128.472 65.3049L126.12 63.3755L123.401 64.266L124.356 61.446L122.739 59.0713Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.548 36.6598L126.414 36.8082L128.252 34.5077L128.987 37.4019L131.779 38.3666L129.207 39.925L129.281 42.8934L126.929 40.964L124.136 41.8545L125.165 39.0345L123.548 36.6598Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.089 28.5709L132.147 26.6414L131.78 23.673L134.352 25.1572L136.924 23.7472L136.336 26.7156L138.468 28.7193L135.454 29.0904L134.131 31.7619L132.882 29.0162L130.089 28.5709Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2094 85.2675L94.0022 85.4159L95.8396 83.1154L96.5746 86.0096L99.3675 86.9001L96.8686 88.5327V91.5011L94.5902 89.5716L91.7973 90.388L92.8263 87.568L91.2094 85.2675Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9131 97.809L97.824 96.6958L98.118 94.3953L99.8084 96.0279L102.013 95.5085L100.984 97.6606L102.234 99.59L99.8819 99.2932L98.412 101L97.8975 98.6995L95.9131 97.809Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.419 92.3174L118.624 92.169L119.873 90.2395L120.682 92.4658L122.96 92.9111L121.122 94.3953L121.416 96.6958L119.432 95.36L117.374 96.3247L117.889 94.0242L116.419 92.3174Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0022 31.5393L65.3385 30.2777L66.8819 25.8251L69.5278 29.8325H74.1581L71.1447 33.543L72.6882 37.9214L68.2049 36.2888L64.4565 38.9603L64.6035 34.2109L61.0022 31.5393Z",
    fill: "#AA946A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.791 59.5908L143.245 62.485L147.728 61.3718L145.891 65.8244L148.537 69.6833L143.759 69.2381L141.04 72.9486L139.938 68.2733L135.601 66.6407L139.57 64.1176L139.791 59.5908Z",
    fill: "#AA946A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstellationB);
export default __webpack_public_path__ + "static/media/constellationB.4816ec53709f0587e0dafd80114ac02b.svg";
export { ForwardRef as ReactComponent };